/* Documents Client barrel export */

import { DocumentFoldersClientMocked, DocumentsClientMocked } from './documentsClientMocked';

// Re-export types
export * from './documentsTypes';

/* ---- Singleton Instances ---- */
// Documents has no real backend yet — always use the in-code mocked clients.

const documentFoldersClient = new DocumentFoldersClientMocked();
const documentsClient = new DocumentsClientMocked();

/** @deprecated Use documentFoldersClient directly */
export function getDocumentFoldersClient() { return documentFoldersClient; }
/** @deprecated Use documentsClient directly */
export function getDocumentsClient() { return documentsClient; }

export { documentFoldersClient, documentsClient, DocumentFoldersClientMocked, DocumentsClientMocked };
// Some pages instantiate their own client instance directly (`new DocumentFoldersClient()`);
// keep these names pointing at the mocked implementation since there's no real backend.
export { DocumentFoldersClientMocked as DocumentFoldersClient };
export { DocumentsClientMocked as DocumentsClient };
